var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile)?_c('div',[_c('div',{staticClass:"view"},[_c('router-view')],1),(_vm.$route.meta.showFooter)?_c('FooterComponent'):_vm._e()],1):_c('div',{staticClass:"page-pc"},[_c('sfQrCode'),_c('FooterComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }